import { render, staticRenderFns } from "./NewPlatform.vue?vue&type=template&id=ac2147a0&scoped=true&"
import script from "./NewPlatform.vue?vue&type=script&lang=js&"
export * from "./NewPlatform.vue?vue&type=script&lang=js&"
import style0 from "./NewPlatform.vue?vue&type=style&index=0&id=ac2147a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2147a0",
  null
  
)

export default component.exports